/* ============
 * Create Page
 * ============
 *
 * This page creates client.
 */

import { mapGetters } from 'vuex';
import stockService from './../../../../services/stock';
import stockTransformer from './../../../../transformers/stock';
import warehouseService from './../../../../services/warehouse';

export default {
  data() {
    return {
      loading: true,
      tabIndex: 'first',
      tabSecond: 'product',
      currentStock: {
        products: [],
        warehouse: {
          name: '',
        },
      },
    };
  },

  computed: {

    productList() {
      return this.currentStock.products.map(c => ({
        sku: c.product.sku,
        name: c.product.name,
        physicalCount: c.physicalCount,
        currentCount: c.currentCount,
        variance: c.variance,
      }));
    },

  },

  watch: {
    currentStock: function(currentStock) {
      console.log(currentStock);
    }
  },

  created() {
    this.loading = false;
  },

  methods: {

  },
  mounted() {
    Promise.all([
      stockService.show(this.$route.params.id),
    ]).then((data) => {
      this.currentStock = data[0];
    });
  },
  components: {
    VTable: require('./../../../../components/table/table.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/stock/view/view.js